var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPepitesTech(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 380,
    viewBox: "0 0 380 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1218_132)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M284 112L324.5 124.5L359.5 97L349.5 51.5L310 39.5L274.5 67L284 112Z",
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145 163.5L161 234.5L234.5 251.5L281 201L265.5 130L190.5 113L145 163.5Z",
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 137.5L88 157.5L115 146.5L121.5 116L96.5 96.5L69.5 107.5L62.5 137.5Z",
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 186.633V252.493H43.9557V243.085H28.434V186.633H19Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1218_132",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 38,
    width: 342,
    height: 304
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 38H361V342H19V38Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1218_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.7507 223.106C64.61 221.91 64.3679 220.892 64.0197 220.051C63.6715 219.208 63.1825 218.572 62.5552 218.138C61.9279 217.709 61.1278 217.49 60.1523 217.49C59.1768 217.49 58.3766 217.732 57.7493 218.217C57.122 218.7 56.6232 219.339 56.2527 220.125C55.8773 220.917 55.6131 221.797 55.4501 222.763C55.2871 223.732 55.2056 224.699 55.2056 225.668V227.27H65.0298C64.9829 225.695 64.8915 224.304 64.7507 223.106ZM55.2056 236.823C55.2056 238.049 55.2871 239.232 55.4501 240.381C55.6131 241.527 55.8773 242.546 56.2527 243.436C56.6232 244.328 57.1097 245.04 57.7123 245.575C58.3173 246.11 59.0607 246.377 59.9448 246.377C61.5698 246.377 62.7528 245.743 63.4962 244.469C64.2395 243.194 64.7507 241.259 65.0298 238.66H73.6686C73.4809 243.45 72.3202 247.092 70.1839 249.589C68.0477 252.087 64.6816 253.334 60.0831 253.334C56.5985 253.334 53.8843 252.695 51.9333 251.423C49.9823 250.151 48.5425 248.467 47.6139 246.377C46.6829 244.291 46.1149 241.946 45.905 239.348C45.695 236.749 45.5913 234.148 45.5913 231.552C45.5913 228.801 45.7667 226.151 46.1149 223.604C46.4631 221.057 47.1595 218.789 48.2042 216.802C49.2513 214.815 50.7479 213.235 52.6989 212.064C54.6475 210.893 57.2505 210.306 60.5005 210.306C63.2862 210.306 65.5756 210.804 67.3636 211.795C69.1492 212.788 70.5568 214.191 71.5793 215.998C72.5992 217.81 73.2957 220 73.6686 222.571C74.039 225.145 74.2267 228.012 74.2267 231.17V233.537H55.2056V236.823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5812 240.417C85.5812 242.202 86.0109 243.641 86.8703 244.736C87.7297 245.831 88.972 246.378 90.597 246.378C92.0837 246.378 93.2667 245.971 94.1533 245.158C95.0325 244.342 95.4745 243.119 95.4745 241.489C95.4745 240.163 95.1263 239.157 94.4299 238.469C93.7334 237.781 92.9209 237.234 91.9923 236.825L85.2329 234.15C82.5855 233.132 80.59 231.694 79.2441 229.833C77.8957 227.974 77.2215 225.59 77.2215 222.688C77.2215 221.004 77.4783 219.412 77.9895 217.91C78.4983 216.409 79.3132 215.095 80.427 213.973C81.5408 212.854 82.9683 211.961 84.7094 211.298C86.4529 210.637 88.5546 210.305 91.0168 210.305C95.3831 210.305 98.6085 211.325 100.7 213.362C102.79 215.403 103.837 218.28 103.837 221.998V223.682H95.1979C95.1979 221.542 94.8843 219.974 94.257 218.98C93.6297 217.987 92.5258 217.489 90.9477 217.489C89.74 217.489 88.683 217.861 87.7767 218.598C86.8703 219.338 86.4184 220.445 86.4184 221.921C86.4184 222.942 86.7073 223.859 87.2877 224.673C87.8705 225.489 88.972 226.179 90.597 226.736L96.3809 228.876C99.4012 229.998 101.537 231.462 102.79 233.272C104.044 235.082 104.669 237.54 104.669 240.648C104.669 242.838 104.323 244.736 103.627 246.341C102.928 247.946 101.965 249.285 100.735 250.352C99.505 251.425 98.0405 252.186 96.3438 252.645C94.6497 253.103 92.7802 253.333 90.7378 253.333C88.0434 253.333 85.8034 253.054 84.0129 252.492C82.2274 251.932 80.8098 251.092 79.7652 249.97C78.7205 248.851 77.9895 247.487 77.5697 245.882C77.1523 244.277 76.9424 242.483 76.9424 240.493V239.041H85.5812V240.417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.432 284.796V307.095H32.8947C35.8928 307.095 37.5252 305.589 37.5252 300.882V291.006C37.5252 286.3 35.8928 284.796 32.8947 284.796H28.432ZM46.9592 291.664V300.227C46.9592 310.764 42.3262 316.5 32.8947 316.5H28.432V341.245H19.0005V275.388H32.8947C42.3262 275.388 46.9592 281.127 46.9592 291.664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7974 261.464L65.0475 271.905H58.703L64.5338 261.464H73.7974ZM60.3305 303.141H73.2812V312.551H60.3305V331.838H76.6276V341.246H50.8989V275.386H76.6276V284.796H60.3305V303.141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0316 284.796V307.095H95.4943C98.4924 307.095 100.125 305.589 100.125 300.882V291.006C100.125 286.3 98.4924 284.796 95.4943 284.796H91.0316ZM109.559 291.664V300.227C109.559 310.764 104.926 316.5 95.4943 316.5H91.0316V341.245H81.6001V275.388H95.4943C104.926 275.388 109.559 281.127 109.559 291.664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.498 275.386H122.93V341.246H113.498V275.386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.188 275.387H155.349V284.795H145.483V341.247H136.049V284.795H126.188V275.387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.034 303.142H180.985V312.549H168.034V331.838H184.331V341.246H158.603V275.386H184.331V284.797H168.034V303.142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.996 274.636C211.173 274.636 215.89 280.656 215.89 291.193V293.264H206.97V290.535C206.97 285.831 205.254 284.041 202.253 284.041C199.252 284.041 197.536 285.831 197.536 290.535C197.536 304.082 215.974 306.624 215.974 325.44C215.974 335.979 211.173 342 201.91 342C192.646 342 187.845 335.979 187.845 325.44V321.396H196.763V326.098C196.763 330.802 198.652 332.498 201.65 332.498C204.654 332.498 206.543 330.802 206.543 326.098C206.543 312.551 188.102 310.011 188.102 291.193C188.102 280.656 192.819 274.636 201.996 274.636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.202 275.387H259.366V284.795H249.499V341.247H240.065V284.795H230.202V275.387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.053 303.142H285.004V312.549H272.053V331.838H288.35V341.246H262.622V275.386H288.35V284.797H272.053V303.142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.679 316.692V325.441C320.679 335.978 315.876 342.001 306.614 342.001C297.351 342.001 292.545 335.978 292.545 325.441V291.192C292.545 280.658 297.351 274.635 306.614 274.635C315.876 274.635 320.679 280.658 320.679 291.192V297.592H311.759V290.537C311.759 285.83 309.872 284.043 306.869 284.043C303.868 284.043 301.981 285.83 301.981 290.537V326.097C301.981 330.804 303.868 332.497 306.869 332.497C309.872 332.497 311.759 330.804 311.759 326.097V316.692H320.679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.995 341.246H325.563V275.386H334.995V303.612H345.718V275.386H355.323V341.246H345.718V313.023H334.995V341.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6773 145.502L106.8 120.008L74.3096 113.985L85.6773 145.502Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6778 145.502L62.2236 137.453L74.31 113.985L85.6778 145.502Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2236 137.454L88.0091 157.667L85.6778 145.503L62.2236 137.454Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6777 145.502L88.0091 157.669L114.886 146.708L85.6777 145.502Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6777 145.502L114.886 146.708L106.801 120.008L85.6777 145.502Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5859 96.2021L121.907 116.07L106.8 120.008L96.5859 96.2021Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.8 120.009L114.885 146.708L121.907 116.069L106.8 120.009Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.8 120.009L96.5852 96.2029L74.3115 113.986L106.8 120.009Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3108 113.985L69.248 107.067L96.5869 96.2019L74.3108 113.985Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2488 107.067L62.2227 137.453L74.3115 113.985L69.2488 107.067Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.2 67.2195L294.408 76.1244L324.829 112.427L341.2 67.2195Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.2 67.2195L359.767 97.5189L324.829 112.427L341.2 67.2195Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.766 97.519L349.794 51.6459L341.199 67.2196L359.766 97.519Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.2 67.2195L349.792 51.6457L309.981 39.2301L341.2 67.2195Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.2 67.2195L309.982 39.2301L294.408 76.1244L341.2 67.2195Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.844 111.755L274.072 66.6906L294.407 76.1256L283.844 111.755Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.408 76.1251L309.984 39.2308L274.073 66.6901L294.408 76.1251Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.407 76.1251L283.845 111.755L324.828 112.428L294.407 76.1251Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.829 112.427L324.081 124.692L283.843 111.756L324.829 112.427Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.082 124.691L359.766 97.5203L324.83 112.426L324.082 124.691Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.879 136.226L188.67 211.331L263.371 191.623L207.879 136.226Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.879 136.226L265.505 129.833L263.372 191.623L207.879 136.226Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.505 129.834L190.804 112.788L207.879 136.226L265.505 129.834Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.879 136.226L190.804 112.788L144.916 162.859L207.879 136.226Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.879 136.226L144.916 162.859L188.67 211.331L207.879 136.226Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.025 251.547L160.657 234.768L188.67 211.332L234.025 251.547Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.669 211.331L144.915 162.859L160.656 234.769L188.669 211.331Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.669 211.331L234.024 251.546L263.37 191.622L188.669 211.331Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.371 191.622L280.979 201.212L234.024 251.548L263.371 191.622Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.979 201.212L265.504 129.834L263.371 191.621L280.979 201.212Z",
    stroke: "#DDDDDD",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1218_132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 342,
    height: 304,
    fill: "white",
    transform: "translate(19 38)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPepitesTech);
export default __webpack_public_path__ + "static/media/logo_pepites_tech.8b25abca2686f8dcb04101cf32d5be11.svg";
export { ForwardRef as ReactComponent };